import { SiteConfig } from '../shared/models/site-config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Account } from '../shared/models';
import { SessionService } from '../shared/session.service';
import { ImplementationOwners } from '../shared/models/implementation-owners.enum';
import { mergeMap, switchMap, take, tap } from 'rxjs/operators';
import { TokenExchangeService } from '../shared/token-exchange.service';

@Injectable()
export class AccountService {
  private baseUrl: string;

  constructor(
    private http: HttpClient,
    private sessionService: SessionService,
    private tokenExchangeService: TokenExchangeService
  ) {
    this.baseUrl = environment.baseUrl;
  }

  getFirst(): Observable<number> {
    return this.http.get<number>(`${this.baseUrl}account/first`);
  }

  account(accountId: number): Observable<Account> {
    const query = new HttpParams().set('accountId', accountId.toString());
    return this.http.get<Account>(`${this.baseUrl}account/account`, { params: query });
  }

  getSiteConfig(): Observable<SiteConfig> {
    return this.http.get<SiteConfig>(`${this.baseUrl}account/config`);
  }

  default(token: string): Observable<number> {
    return this.http
      .post<number>(`${this.baseUrl}account/`, { Token: token });
  }

  defaultImpersonation(token: string): Observable<number> {
    return this.http
      .post<number>(`${this.baseUrl}account/impersonation`, { Token: token });
  }

  implementationOwner(): Observable<ImplementationOwners> {
    return this.sessionService.account
      .pipe(
        mergeMap(x => {
          return this.http.get<ImplementationOwners>(`${this.baseUrl}account/${x.id}/implementationowner`);
        })
      );
  }

  ssoTokenAuthentication(token: string): Observable<Account> {
      return this.sessionService.hasSession.pipe(
        take(1),
        switchMap(hasSession => {
          if (hasSession) {
            return this.sessionService.account.pipe(take(1));
          }
          return this.tokenExchangeService.exchange().pipe(
            switchMap(() => this.default(token)),
            switchMap(accountId => this.account(accountId)),
            tap(account => {
              this.sessionService.setAccount(account);
            })
          );
        })
      );
    }
}
